import styled from "@emotion/styled";
import type { StyledBadgeProps } from "./SvyBadge.interface";

export const Container = styled.div<StyledBadgeProps>`
    --svy-border-radius: ${({ theme }) => theme.spacing[1]};
    --svy-background-color: ${({ theme }) => theme.colors.secondary[200]};
    --svy-text-color: ${({ theme }) => theme.colors.secondary[900]};

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--svy-border-radius);

    background-color: var(--svy-background-color);
    color: var(--svy-text-color);

    padding: 4px 8px;
    width: fit-content;
    ${({ theme }) => {
        return theme.typography["Caption/Bold/Caption1"];
    }};

    ${({ label }) => {
        return !label ? `padding: 4px;` : ``;
    }};

    --svy-background-color: ${({ color, theme }) => {
        switch (color) {
            case "primary":
            case "destructive":
            case "warning":
            case "success":
                return theme.colors[color][100];
            default:
                return theme.colors.secondary[200];
        }
    }};
    --svy-text-color: ${({ color, theme }) => {
        return theme.colors[color ?? "secondary"][900];
    }};
`;

export const BadgeIcon = styled.div`
    --svy-badge-icon-container-width: ${({ theme }) => {
        return theme.spacing[2];
    }};

    max-width: var(--svy-badge-icon-container-width);
    max-height: var(--svy-badge-icon-container-width);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LeftIcon = styled(BadgeIcon)<{ isSingleIcon?: boolean }>`
    ${({ isSingleIcon }) => {
        return isSingleIcon ? `margin-right: 0;` : `margin-right: 4px;`;
    }};
`;

export const RightIcon = styled(BadgeIcon)`
    margin-left: 4px;
`;
